import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AdminProfileResponse, AuthResponse } from "reduxStore/dataTypes";

interface AdminProfileState {
  profile: AdminProfileResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: AdminProfileState = {
  profile: null,
  loading: false,
  error: null,
};

const adminProfileSlice = createSlice({
  name: "adminProfile",
  initialState,
  reducers: {
    adminProfileRequest(state) {
      state.loading = true;
      state.error = null;
    },
    adminProfileSuccess(state, action: PayloadAction<AdminProfileResponse>) {
      state.loading = false;
      state.profile = action.payload;
    },
    adminProfileFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { adminProfileRequest, adminProfileSuccess, adminProfileFailure } =
  adminProfileSlice.actions;
export default adminProfileSlice.reducer;
